import { hoc } from 'src/core/utils';
import { useTryZynProps } from '../../try-zyn.props';
import { Button, Input } from 'src/core/components';
import OtpInput from 'react-otp-input';
import styles from './popup.module.scss';
import classNames from 'classnames';
import { page } from 'src/locale';

const Popup = ({ props }) => {
  const {
    handleClose,
    popupType,
    loading,
    time,
    setSubscription,
    code,
    onKeyDown,
    onCheckOtp,
    errors,
    handleClick,
    onCallMe,
    callMe,
    calling,
    subscription,
    locale,
    errorOtp
  } = props;
  return (
    <div className={styles.back}>
      <div
        className={classNames(
          styles.popup,
          loading && styles.loading_popup,
          styles[`popup_${popupType}`]
        )}
      >
        {loading ? (
          <div className={styles.loader} />
        ) : (
          <div
            className={classNames(
              styles.wrapper,
              popupType !== 'form' &&
                popupType !== 'otp' &&
                styles.loading_wrapper
            )}
          >
            <div className={styles.cross} onClick={() => handleClose()} />
            <h2 className={styles.title}>
              {page.popup[popupType].title[locale]}
            </h2>
            <p className={styles.text}>
              {calling && popupType === 'otp'
                ? page.popup.otp.calling_text[locale]
                : page.popup[popupType].text[locale]}
              {popupType === 'otp' && !calling && (
                <b>
                  {' '}
                  {+time <= 0 ? '0' : time} {page.popup.otp.time[locale]}
                </b>
              )}
            </p>
            {popupType === 'otp' && (
              <>
                <div
                  className={classNames(
                    styles.inputWrapper,
                    errorOtp && styles.inputWrapper_error
                  )}
                >
                  <OtpInput
                    inputStyle={classNames(styles.inputStyle, {
                      [styles.error]: errorOtp && code.length === 6 && true
                    })}
                    skipDefaultStyles
                    renderInput={props => (
                      <input {...props} onKeyDown={onKeyDown} />
                    )}
                    value={code}
                    onChange={onCheckOtp}
                    numInputs={6}
                    containerStyle={classNames(styles.otpContainer, {
                      [styles.inputStyle_container_with_first]: code.length > 0,
                      [styles.inputStyle_container_with_second]:
                        code.length > 1,
                      [styles.inputStyle_container_with_third]: code.length > 2,
                      [styles.inputStyle_container_with_fourth]:
                        code.length > 3,
                      [styles.inputStyle_container_with_fifth]: code.length > 4,
                      [styles.inputStyle_container_with_sixth]: code.length > 5
                    })}
                    renderSeparator={<span />}
                    inputType='number'
                  />
                </div>
                {((errors?.otp && code.length === 6) ||
                  (errorOtp && code.length === 6)) && (
                  <div className={styles.errorText}>
                    <p>
                      Неправильний код. Перевір і спробуй ще раз, будь ласка.
                    </p>
                  </div>
                )}
                <div className={styles.legal}>
                  {page.popup.otp.legal_text[locale]}
                  <a href={page.popup.otp.legal_link[locale]}>
                    {page.popup.otp.legal_link_text[locale]}
                  </a>
                </div>
                <div
                  onClick={() => setSubscription(!subscription)}
                  className={classNames(
                    styles.subscription,
                    subscription && styles.subscription_checked
                  )}
                >
                  <span>{page.popup.otp.subscription[locale]}</span>
                </div>
              </>
            )}
            <div className={styles.button_wrapper}>
              <Button
                onClick={handleClick}
                className={classNames(styles.button, styles.blue)}
                disabled={popupType === 'otp' && code.length !== 6}
                color='primary'
              >
                {page.popup[popupType].button[locale]}
              </Button>
              {time == 0 && !callMe && popupType === 'otp' && (
                <p
                  // color="septenary"
                  onClick={onCallMe}
                  className={styles.button_call}
                >
                  {page.popup.otp.callme[locale]}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { Popup };
